import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.className)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["sf-field-error-message tw-text-right", { 'prevent-wrap': _ctx.preventWrap }])
    }, "   " + _toDisplayString(_ctx.errorMessage), 3)
  ], 2))
}